import { render } from "./ICUBox.vue?vue&type=template&id=05038c8b&scoped=true&ts=true"
import script from "./ICUBox.vue?vue&type=script&lang=ts"
export * from "./ICUBox.vue?vue&type=script&lang=ts"

import "./ICUBox.vue?vue&type=style&index=0&id=05038c8b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05038c8b"]])

export default __exports__